// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { AngryAnalytics } from "../../game_logic/code/Analytics/Analytics";
export var TimeCalculator = function () {
};
TimeCalculator._events = [];
TimeCalculator.markStart = function (eventName) {
    TimeCalculator._events.push({
        name: eventName,
        start: Date.now(),
        end: null,
        duration: null
    });
};
TimeCalculator.markEnd = function (eventName) {
    for (var i = 0; i < TimeCalculator._events.length; i++) {
        if (TimeCalculator._events[i].name === eventName) {
            TimeCalculator._events[i].end = Date.now();
            TimeCalculator._events[i].duration = TimeCalculator._events[i].end - TimeCalculator._events[i].start;
            return;
        }
    }
};
TimeCalculator.print = function () {
    var total = 0;
    for (var i = 0; i < TimeCalculator._events.length; i++) {
        var duration = TimeCalculator._events[i].duration ? TimeCalculator._events[i].duration : 0;
        console.log(TimeCalculator._events[i].name + " took " + duration + "ms");
        total += duration;
    }
    console.log("TOTAL: " + total);
};
// Takes an array of strings
TimeCalculator.sendAnalyticsEvents = function (eventNames) {
    if (!eventNames)
        return;
    for (var e = 0; e < eventNames.length; e++) {
        for (var i = 0; i < TimeCalculator._events.length; i++) {
            if (eventNames[e] === TimeCalculator._events[i].name) {
                AngryAnalytics.reportLoadComplete(TimeCalculator._events[i].name, TimeCalculator._events[i].duration);
                i = TimeCalculator._events.length;
            }
        }
    }
};
// Send analytic event for FBInstant loading to be done
//AngryAnalytics.reportLoadComplete("fbLoader_done",  Date.now() - this._fbInstantLoadStartedTime);
